import * as React from "react";
import { connect } from "react-redux";
import Label from "../../components/Label";
import ErrorMessage from "../../components/ErrorMessage";
import PlacesAutocomplete, { geocodeByAddress } from "react-places-autocomplete";
import "../../../assets/sass/widgets/typeAhead.scss";
import IProps from "./IProps";
import { bindActionCreators } from "redux";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { validationCheck } from "../../utils/validation";
import {
    getDataFromStore,
    checkForReadOnly,
    specialCharacterCheck,
    dropCheck,
    preventSpecialCharacters,
    getPriceCheckDetails,
} from "../../utils/utils";

/**
 * @ignore
 */
interface IState {
    address: any;
    error: any;
}
/**
 * @class TypeAhead
 * @category Widgets
 * @description This component renders the input box for street address and uses react-places-autocomplete library to display the suggestion list to the user based on the input , this handles assigning the values to the state, city, zipcode  once the user selects one of the lists from suggestion
 */
class TypeAhead extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            address: this.props.value || "",
            error: { error: false, errorMessage: [] },
        };
        this.onBlurCheck = this.onBlurCheck.bind(this);
    }
    componentDidMount() {
        if (this.props.value) this.handleChange(this.props.value);
    }
    componentDidUpdate(prevProps, nextProps) {
        const { onChange, schema, value: propValue, warrantyData } = this.props;
        if (prevProps.schema.const.family !== this.props.schema.const.family) {
            this.setState({
                error: { error: false, errorMessage: [] },
            });
        }
        if ((!prevProps.warrantyData || Object.keys(prevProps.warrantyData).length === 0) && warrantyData) {
            if (propValue) {
                this.handleChange(propValue);
            }
        } else {
            if (schema.const && schema.const.dataSource && schema.const.dataSource.length > 0) {
                const value = getDataFromStore(schema.const.dataSource, this.props, this.state.address);
                if (value != undefined) {
                    this.setState({ address: value }, () => {
                        onChange(value);
                    });
                }
            }
        }
    }

    /**
     *
     * @param nextProps
     */
    // componentWillReceiveProps(nextProps: any) {
    //  const {onChange}=this.props;
    //  const currentId = this.props.id;
    //  let newAddressValue;
    //  if( currentId.includes("mailWarrantyInfo")) {
    //   newAddressValue = nextProps.mailAddress;
    //  }else {
    //   newAddressValue = nextProps.buildingAddress;
    //  }
    //   if (newAddressValue && newAddressValue.street !== this.state.address) {
    //     this.setState({ address: nextProps.addressValue.street });
    //      onChange(nextProps.addressValue.street);
    //   }
    // }
    /**
     *
     */
    formatAddress = (addressComponent) => {
        const address = {
            address1: "",
            neighborhood: "",
            subLocality: "",
            locality: "",
            state: "",
            zip: "",
            city: "",
        };
        if (!addressComponent) {
            return address;
        }
        addressComponent.forEach((value) => {
            const { types } = value;
            const longName = value.long_name;
            const shortName = value.short_name;
            const isStreetName = types.indexOf("street_number") > -1;
            const isRoute = types.indexOf("route") > -1;
            const subLocality = types.indexOf("sublocality_level_1") > -1;
            const isNeighborhoodAddress = types.indexOf("neighborhood") > -1;
            const isLocality = types.indexOf("locality") > -1;
            const isState = types.indexOf("administrative_area_level_1") > -1;
            const isPostalCode = types.indexOf("postal_code") > -1;

            if (isStreetName) address.address1 = longName;
            if (isRoute) address.address1 = `${address.address1 || ""} ${longName}`;
            if (isNeighborhoodAddress) address.neighborhood = longName;
            if (subLocality) address.subLocality = longName;
            if (isLocality) address.locality = longName;
            if (isState) address.state = shortName;
            if (isPostalCode) address.zip = longName;
        });
        const { neighborhood, subLocality, locality } = address;
        return {
            ...address,
            city: locality || subLocality || neighborhood,
        };
    };

    handleSelect = (value, placeId) => {
        const { selectAddress } = this.props.dynamicFormActions;
        const { buildingAddress, mailAddress } = this.props;
        const currentId = this.props.id;
        const buildingAddressUpdated = {
            street: "",
            city: "",
            zip: "",
            state: "",
            province: "",
            postalCode: "",
            countryCode: buildingAddress.countryCode,
        };
        const mailAddressUpdated = {
            street: "",
            city: "",
            zip: "",
            state: "",
            postalCode: "",
            countryCode: mailAddress.countryCode,
        };
        let addressObject;
        let addressKey;
        if (currentId.includes("mailWarrantyInfo")) {
            addressObject = mailAddressUpdated;
            addressKey = "mailAddress";
        } else {
            addressObject = buildingAddressUpdated;
            addressKey = "buildingAddress";
        }
        let addressComponents = null;
        geocodeByAddress(value).then((results) => {
            [addressComponents] = results;
            const formatedAddress = this.formatAddress(addressComponents.address_components);
            addressObject.street = formatedAddress.address1;
            addressObject.city = formatedAddress.city;
            addressObject.state = formatedAddress.state;
            addressObject.zip = formatedAddress.zip;
            addressObject.postalCode = formatedAddress.zip;
            addressObject.province = formatedAddress.state;
            this.setState({ address: addressObject.street }, () => {
                this.props.onChange(addressObject.street);
            });
            selectAddress({ key: addressKey, payload: addressObject });
        });
    };

    /**
     *
     */
    handleChange = (value) => {
        const { buildingAddress, mailAddress } = this.props;
        const { selectAddress } = this.props.dynamicFormActions;
        const currentId = this.props.id;
        if (currentId.includes("mailWarrantyInfo")) {
            mailAddress.street = value;
            this.setState(
                {
                    address: value,
                    // error: validationCheck(value, fieldName, family, errorSchema), // Comment, due to validate the same on blur
                },
                () => {
                    selectAddress({ key: "mailAddress", payload: mailAddress, label: "street" });
                    this.props.onChange(value);
                }
            );
        } else {
            buildingAddress.street = value;
            this.setState(
                {
                    address: value,
                    // error: validationCheck(value, fieldName, family, errorSchema), // Comment, due to validate the same on blur
                },
                () => {
                    selectAddress({ key: "buildingAddress", payload: buildingAddress, label: "street" });
                    this.props.onChange(value);
                }
            );
        }
    };

    /**
     * @function onBlurCheck
     * @param event
     * @description
     *      1: Validates the targeted value with that comming in from the errorSchema
     * @ignore
     */
    onBlurCheck(event) {
        const { family } = this.props.schema.const;
        const { errorSchema } = this.props;
        const id = this.props.id.split("_");
        const fieldName = this.props.id.split("_")[id.length - 1];
        const validationError = validationCheck(event.target.value, fieldName, family, errorSchema);
        if (validationError && validationError.error) {
            this.setState({
                error: validationCheck(event.target.value, fieldName, family, errorSchema),
            });
        } else {
            this.setState({ error: { error: false, errorMessage: [] } });
        }
    }

    fieldClicked = () => {
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        removeFieldIdFromStore(this.props.id);
    };

    // onInputBoxKeyDown = (evt) => {
    //     ["?", "<", ">", "&", '"', "(", ")", "#", "%", ";", "+"].includes(evt.key) && evt.preventDefault();
    // };

    // specialCharacterCheck = (e) => {
    //     const pastedData = e.clipboardData.getData("Text");
    //     const regSpclChar = /[\^<>&"()#%;+?]/;
    //     if (regSpclChar.test(pastedData)) {
    //         e.preventDefault && e.preventDefault();
    //         return false;
    //     }
    // };
    // dropCheck = (ev) => {
    //     const src = window.getSelection().toString();
    //     const regSpclChar = /[\^<>&"()#%;+?]/;
    //     if ((src && regSpclChar.test(src)) || src === "") {
    //         ev.preventDefault && ev.preventDefault();
    //         return false;
    //     }
    // };

    render() {
        const { schema, buildingAddress, mailAddress, id, isSubmittedForm, errorDetails, errorSchema } = this.props;
        const { address, error } = this.state;
        const currentId = this.props.id;
        let countryCode;
        const { family, fieldName } = getPriceCheckDetails(errorSchema, schema, id);
        if (currentId.includes("mailWarrantyInfo")) {
            countryCode = mailAddress.countryCode;
        } else {
            countryCode = buildingAddress.countryCode;
        }
        return (
            <div onBlur={this.onBlurCheck}>
                <Label schema={schema} />
                <PlacesAutocomplete
                    value={address}
                    onChange={this.handleChange}
                    onSelect={this.handleSelect}
                    searchOptions={{
                        componentRestrictions: { country: countryCode },
                        types: ["address"],
                    }}
                >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div
                            className={
                                (this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0) ||
                                (this.props.errorDetails[id] && this.props.errorDetails[id].length > 0)
                                    ? "error-boundry"
                                    : "inputbox-rectangle"
                            }
                        >
                            <input
                                id={id}
                                tabIndex={schema.const.tabIndex}
                                className="gaf-inputbox"
                                {...getInputProps()}
                                onFocus={this.fieldClicked}
                                disabled={checkForReadOnly(schema.const, isSubmittedForm)}
                                onKeyDown={preventSpecialCharacters}
                                onPaste={(e) =>
                                    specialCharacterCheck(
                                        e,
                                        {
                                            value: e.target["value"],
                                            fieldName,
                                            family,
                                            errorSchema,
                                        },
                                        schema.type
                                    )
                                }
                                onDrop={(e) => dropCheck(e, schema.type)}
                            />
                            <div>
                                {loading ? <div>...</div> : null}
                                {suggestions.map((suggestion, index) => {
                                    const style = {
                                        backgroundColor: suggestion.active ? "#dedede" : "white",
                                        borderLeft: "1px solid #b7b7b7",
                                        borderRight: "1px solid #b7b7b7",
                                        padding: "10px",
                                    };
                                    return (
                                        <div key={index} className="suggestion-div">
                                            <div {...getSuggestionItemProps(suggestion, { style })}>
                                                {suggestion.description}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </PlacesAutocomplete>
                <ErrorMessage errorDetails={errorDetails} errorState={error} propId={id} />
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        countryCode: state.dynamicFormInfo.countryCode,
        buildingAddress: state.dynamicFormInfo.global.buildingAddress,
        mailAddress: state.dynamicFormInfo.global.mailAddress,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        isSubmittedForm: state.adminData.isSubmittedForm,
        warrantyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
    };
};

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}

/**
 *
 */
export default connect(mapStateToProps, mapDispatchToProps)(TypeAhead);
